/*------------------------------------*\
    DISCOURAGE IMAGE THEFT
\*------------------------------------*/
class DiscourageImageTheft {
    constructor() {
        let self = this;
    }

    init() {
        let self = this;

        const images = [...document.querySelectorAll('img')];

        images.map(image => {
            image.addEventListener('contextmenu', evt => {
                evt.preventDefault();
            });

            image.addEventListener('mousedown', evt => {
                evt.preventDefault();
            });
        });
    }
}

export default DiscourageImageTheft;
